import { DealerState } from './types';

export const getDealerId = (state: DealerState) => state.dealer.dealerID;
export const getDealerStockId = (state: DealerState) => state.dealer.stockDealerID;
export const getDealerName = (state: DealerState) => state.dealer.dealerName;
export const getDealerLocationName = (state: DealerState) => state.dealer.locationName;
export const getDealerPrivacyPolicy = (state: DealerState) => state.dealer.privacyPolicy;
export const getDealerPhone = (state: DealerState) => state.dealer.phone;
export const getDealerOpeningHours = (state: DealerState) => state.dealer.openingHours;
export const getDealerWebsite = (state: DealerState) => state.dealer.website;
export const getDealerTerms = (state: DealerState) => state.dealer.terms;
export const getDealerAddress = (state: DealerState) => state.dealer.address;
